/*
 * Makes header fixed to the top after section 3 animation.
 * Uses a different workflow for mobile viewports: Toggles
 * class based on scroll offset
 *
 * @author BarrelNY
 * @link https://github.com/alvarotrigo/fullPage.js
 *
 */

var Header = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.home-page'
		].join();

		if (!$(templates).length) return;

		this.events();
	},

	events:function(){
		$('body')
			.on('fullPage__onLeave',$.debounce(20,this.toggleState));

		$(window)
			.on('scroll',$.debounce(100,this.mobileHeader));
	},

	/*
	 * Toggle a clone variation of the header
	 * to display after section 3
	 *
	 * @param	obj	event object
	 * @param	string	index we're moving away from
	 * @param	string	index we're moving towards
	 * @param	string	the direction we are going
	 * @returns void
	 */
	toggleState:function(e, index, nextIndex, direction){
		if ( MUR.isSmall() ) return;

		var action = false;

		if (index == 2 && nextIndex == 3){
			action = 'fix';
		} else if(index == 3 && nextIndex == 2){
			action = 'scroll';
		} else {
			return;
		}

		var $header = $('.header-wrapper');

		switch (action){
			case 'fix':
				setTimeout(function(){
					//Only add if doesn't exist
					$clone = $('.header-wrapper.clone')

					if ( !$clone.length ){
						var clone = $header.eq(0).clone();
						$('#ajax-content-container').prepend(clone.addClass('clone'));
					}
				},MUR.animation.duration);
			break;
			case 'scroll':
				//Remove all..
				$('.header-wrapper.clone').remove();
			break;
		}
	},

	/*
	 * Toggle the mobile menu via a
	 * Mock waypoint
	 *
	 * @params	void
	 * @returns	void
	 */
	mobileHeader:function(){
		var
			offset = $('.section-3').position().top,
			scroll = $(window).scrollTop(),
			$el = $('.mobile-header .header-wrapper');

		if (scroll >= offset){
			$el.addClass('show');
		} else {
			$el.removeClass('show');
		}
	},

	drop:function(){
		$('.header-wrapper.clone').fadeOut().remove();
	}
}

module.exports = Header;
